import { Component, Input, ViewChild, ElementRef, OnChanges, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Note, OfferNotes, OfferType } from 'src/app/shared/models/offers.model';
import { FeatureFlag } from '../../models/enums/feature-flag';
import { OffersUserType } from 'src/app/shared/models/enums/offers.enum';
import { LDFeatureManager } from 'src/app/shared/services/ld-feature-manager';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CommonModule } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';

@UntilDestroy()
@Component({
    selector: 'nova-shared-notes',
    templateUrl: './notes-display.component.html',
    styleUrls: ['./notes-display.component.scss'],
    standalone: true,
    imports: [CommonModule, MatChipsModule]
})
export class SharedNotesComponent implements OnChanges, OnInit {
    readonly featureFlag = FeatureFlag;
    notes: Observable<Note[]>;
    @Input() agencyNotes: OfferNotes[];
    @Input() offerType: OfferType;
    @Input() userType?: OffersUserType;
    @Input() headingTitle = '';
    @Input() headingTitleSubtext = '';
    @ViewChild('scrollMe', { static: false }) private myScrollContainer: ElementRef;

    isRecruiterSpecificOfferNoteFlagEnabled = false;

    constructor(private readonly _featureManager: LDFeatureManager) {}

    ngOnChanges(changes) {
        if (changes['agencyNotes'] && this.agencyNotes) {
            setTimeout(() => {
                this.scrollToBottom();
            }, 300);
        }
    }

    scrollToBottom(): void {
        try {
            this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
        } catch (err) {
            console.log('ERROR: ', err);
        }
    }

    ngOnInit() {
        this._featureManager
            .isEnabled(FeatureFlag.ConnectVMSRecruiterSpecificOfferNotes)
            .pipe(untilDestroyed(this))
            .subscribe((isEnabled) => {
                this.isRecruiterSpecificOfferNoteFlagEnabled = isEnabled;
            });
    }

    shouldDisplayCategoryChips(note: OfferNotes) {
        return (
            this.isRecruiterSpecificOfferNoteFlagEnabled &&
            this.offerType === OfferType.Direct &&
            this.userType &&
            (this.userType === OffersUserType.AccountManager || this.userType === OffersUserType.Recruiter) &&
            note.category?.length > 0
        );
    }

    shouldDisplayTitleOnNewLine(note: OfferNotes) {
        return this.shouldDisplayCategoryChips(note) && note.title?.length > 0;
    }
}
